import React, { memo, useMemo, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { CustomDialog } from "../../../../../components/customDialog/CustomDialog";
import { IndicadorEstado } from '../../IndicadorEstado/IndicadorEstado';

export const FinanciadorEstado = memo(function FinanciadorEstado({
    requisitoCliente,
    clienteBloqueadoPorSAP,
    idCliente,
    clienteAutorizado
}) {
    const [openModal, setOpenModal] = useState(false);
    const condicionCrediticia = requisitoCliente.idTipoAutorizacion === 1;
    const algunBloqueo = Boolean(requisitoCliente?.bloqueoPaciente || requisitoCliente?.bloqueoProrroga || requisitoCliente?.bloqueoCotizar || requisitoCliente?.bloqueoEnvio);
    const bloqueoTotal = Boolean((requisitoCliente?.bloqueoPaciente && requisitoCliente?.bloqueoProrroga && requisitoCliente?.bloqueoCotizar && requisitoCliente?.bloqueoEnvio));
    const sinBloqueos = !algunBloqueo && !clienteBloqueadoPorSAP;

    const getMensajeA = (condicionCrediticia, bloqueoTotal) => {
        if (clienteAutorizado) {
            return "El cliente cuenta con autorización inmediata.";
        } else if (bloqueoTotal) {
            return "El cliente posee un bloqueo total.";
        } else {
            return "El cliente no cuenta con autorización inmediata.";
        }
    };

    const getMensajeB = (sinBloqueos, algunBloqueo) => {
        if (sinBloqueos) {
            return "El cliente no posee ningún bloqueo.";
        } else if (algunBloqueo) {
            return "El cliente posee algún bloqueo.";
        } else {
            return "";
        }
    };

    const getMensajeC = (clienteBloqueadoPorSAP) => {
        return `El cliente${!clienteBloqueadoPorSAP ? ' no' : ''} posee un bloqueo en SAP.`;
    };


    const mensajes = [
        getMensajeA(condicionCrediticia, bloqueoTotal),
        getMensajeB(sinBloqueos, algunBloqueo),
        getMensajeC(clienteBloqueadoPorSAP)
    ].filter(Boolean);

    const mensajesConPrefijo = mensajes.map((mensaje, index) => {
        const prefijo = String.fromCharCode(97 + index) + '. '; // 'a' es 97 en ASCII
        return prefijo + mensaje;
    });

    const handleOpenModal = () => {
        if (idCliente) {
            setOpenModal(true);
        }
    };

    const handleClose = () => {
        setOpenModal(false);
    }

    const states = useMemo(() => {
        return {
            success: condicionCrediticia && sinBloqueos && idCliente,
            error: (bloqueoTotal || clienteBloqueadoPorSAP) && idCliente,
            warning: (!condicionCrediticia || algunBloqueo) && !bloqueoTotal && idCliente
        };
    }, [condicionCrediticia, sinBloqueos, idCliente, bloqueoTotal, clienteBloqueadoPorSAP]);

    const stateType = useMemo(() => {
        if (states.error) return 'error';
        if (states.warning) return 'warning';
        if (states.success) return 'success';
        return 'empty';
    }, [states]);

    const getTitle = () => {
        if (states.success) return "Aprobaciones";
        if (states.error) return "Bloqueos";
        if (states.warning) return "En Proceso";
        return null;
    };

    const title = useMemo(getTitle, [states]);

    return <>
 <Grid size={{ xs: 20, sm: 10, md: 5, lg: 5 }}>
            <IndicadorEstado
                type={stateType}
                onClick={handleOpenModal}
            />
        </Grid>
        <CustomDialog
            fullWidth
            onCancel={handleClose}
            open={openModal}
            cancelText='Cerrar'
        >
            <Grid
                container
                justifyContent={'center'}
            >
 <Grid size={{ xs: 12 }}>
                    <Grid container columns={20} columnSpacing={2}>
 <Grid xs='auto' size="grow">
                            <IndicadorEstado
                                type={stateType}
                                onClick={handleOpenModal}
                            />
                        </Grid>
 <Grid size={{ xs: 10 }}>
                            <Typography variant='h5' sx={{ width: '50%' }}>{title}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
 <Grid sx={{ marginTop: '10px' }} size={{ xs: 12 }}>
                    {mensajesConPrefijo.map((mensaje) => (
                        <p key={mensaje}>{mensaje}</p>
                    ))}
                </Grid>
            </Grid>
        </CustomDialog>
    </>
})